import React from "react";
import schemeSvg from "../../../assets/svg/scheme.svg";
import svg22 from "../../../assets/svg/svg22.svg";
import svg23 from "../../../assets/svg/svg23.svg";
import svg24 from "../../../assets/svg/svg24.svg";
import { numberWithCommas } from "../../../utils";

// Icons map from the card key, never the title
const svgMap = {
  schemesReporting: schemeSvg,
  cropAcreage: svg24,
  totalProduction: svg22,
  averageYield: svg23,
};

function ProductionDataCard({ data }) {
  // A null figure means there was nothing to sum - render it as "--", not zero
  const figure = (value, unit) =>
    value || value === 0
      ? `${numberWithCommas(value)}${unit ? ` ${unit}` : ""}`
      : "--";

  return (
    <div className="mt-[1.75rem] flex flex-shrink flex-wrap gap-[1.75rem]">
      {data?.map((item) => (
        <div
          key={item?.key}
          className="rounded-[.75rem] border border-[#D6E1F5] bg-[#F7F7F7] lg:w-[17.75rem] w-full p-[.75rem]"
        >
          <div className="flex items-center justify-between">
            <div className="scheme-card-title">{item?.title}</div>
            <img src={svgMap[item?.key] ?? schemeSvg} alt={item?.key} />
          </div>
          <div
            className={`scheme-card-content mt-[1rem] ${
              item?.value == 0 && "!text-[#DD2222]"
            }`}
          >
            {figure(item?.value, item?.unit)}
          </div>
          <div className="proj_desc mt-[.25rem]">{item?.subtitle}</div>

          {item?.breakdown?.length > 0 && (
            <div className="mt-[.5rem] flex flex-col gap-[.25rem]">
              {item?.breakdown?.map((crop) => (
                <div
                  key={crop?.name}
                  className="flex items-center justify-between proj_desc !text-[#111928]"
                >
                  <span>{crop?.name}</span>
                  <span className="font-[500]">
                    {numberWithCommas(crop?.value ?? 0)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default ProductionDataCard;
